<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <div class="top">
        <el-tabs v-model="activeName">
          <el-tab-pane label="用户详情"
                       name="first">
            <DserDetails></DserDetails>
          </el-tab-pane>
          <el-tab-pane label="编辑资料"
                       name="second">
            <EditMaterials></EditMaterials>
          </el-tab-pane>
          <el-tab-pane label="登录日志"
                       name="third">
            <LoginJournal></LoginJournal>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-card>
</template>

<script>
import DserDetails from './user-details'
import EditMaterials from './edit-materials'
import LoginJournal from './login-journal'

export default {
  data () {
    return {
      dataForm: {
        creatorName: ''
      },
      activeName: 'first'
    }
  },
  methods: {
  },
  components: {
    DserDetails,
    EditMaterials,
    LoginJournal
  }
}
</script>
